import { configPromise } from "../../config/configMiddleware";
import { getWith } from "../axios";

export interface GetCurrentUserResponse {}

export async function GetRegionsList(): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/common/fetch-countries/contact_number`;
    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}
